import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
  href?: string;
  onClick?: () => void;
}
export function CTAButton({
  text = 'SÍ, QUIERO MI BUNDLE HÍGADO VITAL AHORA',
  className = '',
  href = '#oferta',
  onClick
}: CTAButtonProps) {
  return <motion.a href={href} target={href.startsWith('http') ? '_blank' : undefined} rel={href.startsWith('http') ? 'noopener noreferrer' : undefined} onClick={onClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        relative flex items-center justify-center w-full py-4 px-6 
        bg-accent text-dark font-bold text-lg md:text-xl rounded-full 
        shadow-soft hover:shadow-glow transition-shadow duration-300
        overflow-hidden group text-center leading-tight
        ${className}
      `} data-id="element-56">
      <span className="relative z-10 flex items-center gap-2" data-id="element-57">
        {text}
        <ChevronRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-58" />
      </span>
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-59" />
    </motion.a>;
}